import React from 'react';
import { map, sortBy } from 'lodash';
import { ASSET_TYPES_MS, allAssetTypes } from 'helpers/constants';
import { allAssetTypeFilter } from 'helpers/filterHelper';
import { getAssetIcon } from 'helpers/icons';
import colors from 'theme/_colors.scss';


// eslint-disable-next-line import/no-unused-modules
export const getFormattedAssetTypes = (translate) => {
    const options = [];

    const types = Object.keys(ASSET_TYPES_MS);

    map(types, (type) => {
        const label = translate(`ABB.Powertrain.Frontend.${ASSET_TYPES_MS[type]?.toLowerCase()}Label`) ||
            ASSET_TYPES_MS[type];
        options.push({
            id: ASSET_TYPES_MS[type],
            title: <>{getAssetIcon(ASSET_TYPES_MS[type], { width: 16, height: 16 })} {label}</>,
            assetType: label
        });
    });

    return [
        {
            id: allAssetTypes,
            title: translate('ABB.Powertrain.Frontend.allassettypesLabel')
        },
        ...sortBy(options, [option => option?.assetType])
    ];
};

export const getFormattedAssetType = (type, translate) => {
    if (type) {
        const label = translate(`ABB.Powertrain.Frontend.${type?.toLowerCase()}Label`) || type;
        return {
            id: type,
            title: <>{getAssetIcon(type, { width: 16, height: 16 })} {label}</>,
        };
    }
};

export const customMultiSelectStyles = {
    control: (provided) => ({
        ...provided,
        width: 'min(316px, 90vw)',
        borderRadius: 0,
        minHeight: 32
    }),
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: 'nowarp'
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: '50px'
    }),
    option: (base, state) => {
        let backgroundColor = colors.white;
        let color = colors.black;

        if (state?.isSelected) {
            backgroundColor = colors.white;
            color = colors.black;

        }
        if (state?.isFocused && !state?.isSelected) {
            backgroundColor = colors.altoTransparent;
            color = colors.black;
        }

        return {
            ...base,
            backgroundColor,
            color
        };
    }

};

export const getSubscriptionListOptions = (subscriptionTypes) =>
    subscriptionTypes?.map(({ name }) => ({
        label: name,
        value: name,
    })) || [];


export const getSubsciptionTypeFilterValue = (subscriptionTypes, subscriptionTypeFilter) => {
    const getSubscriptionLists = getSubscriptionListOptions(subscriptionTypes);
    return getSubscriptionLists?.filter((subscriptionType) => subscriptionTypeFilter?.includes(subscriptionType.value));
};
export const setOptions = (assets, translate) => {
    // Extract unique asset types using a Set for better performance
    const assetTypes = [...new Set(assets.map((obj) => obj?.assetType))];

    // Map asset types to options
    const options = assetTypes.map((assetType, index) => {
        const label = translate(`ABB.Powertrain.Frontend.${assetType?.toLowerCase()}Label`) || assetType;
        return {
            id: index + 1,
            title:
                <>
                    {getAssetIcon(assetType, { width: 16, height: 16 })} {label}
                </>
            ,
            assetType,
            assetTypeLabel: label,
        };
    });

    // Return the combined options with sorting
    return [allAssetTypeFilter(translate), ...sortBy(options, 'assetTypeLabel')];
};

export const compactMultiSelectStyles = {
    ...customMultiSelectStyles,
    control: (provided) => ({
        ...provided,
        width: 'min(200px, 80vw)',
        borderRadius: 0,
        minHeight: 32
    })
};
